import {
  shoutouts_returned,
  shoutouts_before_returned,
  new_shoutout_received,
  comment_received,
  comment_deleted,
  user_signed_out,
  all_shoutouts_loaded,
  shoutouts_requested,
  shoutout_feed_initialized,
  shoutout_returned,
  show_image,
  shoutout_deleted,
  shoutout_updated
} from '../actions/types';

const INITIAL_STATE = {
  after: '',
  shoutoutsLoading: false,
  shoutouts: [],
  tvShoutouts: [],
  newShoutout: null,
  allShoutoutsLoaded: false,
  image: ''
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case shoutout_feed_initialized:
      return INITIAL_STATE;

    case shoutouts_requested:
      return { ...state, shoutoutsLoading: true };

    case shoutouts_returned: {
      const newShoutouts =  [...state.shoutouts, ...action.payload.shoutouts];
      const found = [];

      return {
        ...state,
        after: action.payload.after,
        shoutouts: newShoutouts.filter((shoutout)=> {
          if (found.indexOf(shoutout._id) === -1){
            found.push(shoutout._id);
            return true;
          }
          return false;
        }),
        shoutoutsLoading: false
      };
    }
    case shoutouts_before_returned:
      return { ...state, tvShoutouts: [ ...action.payload ], shoutoutsLoading: false };

    case new_shoutout_received:
      return { ...state, shoutouts: [ ...state.shoutouts, action.payload ], newShoutout: action.payload };

    case all_shoutouts_loaded:
      return { ...state, allShoutoutsLoaded: true };

    case comment_received: {
      const comment = action.payload;

      for (let i in state.shoutouts) {
        if (state.shoutouts[i]._id === comment.shoutout_id) {
          state.shoutouts[i].comments.push(comment._id);
          break;
        }
      }

      return { ...state, shoutouts: [...state.shoutouts] };
    }
    case comment_deleted: {
      let index;
      const shoutout = state.shoutouts.find((shoutout, i) => {
        if (shoutout._id === action.payload.shoutout_id) {
          index = i;
          return true;
        }

        return false;
      });

      if (shoutout) {
        const commentIndex = shoutout.comments.indexOf(action.payload.id);
        shoutout.comments.splice(commentIndex, 1);
        state.shoutouts[index] = { ...shoutout };
      }

      return { ...state, shoutouts: [...state.shoutouts] };
    }
    case user_signed_out: {
      return { ...INITIAL_STATE };
    }
    case shoutout_returned:
      if (action.payload) {
        return { ...state, shoutouts: [...state.shoutouts, action.payload] };
      } else {
        return { ...state };
      }

    case show_image: {
      return { ...state, image: action.payload };
    }

    case shoutout_deleted: {
      let shoutouts = [ ...state.shoutouts ];
      let index = shoutouts.indexOf(shoutouts.find((shoutout) => shoutout._id === action.payload._id));
      shoutouts.splice(index, 1);
      return { ...state, shoutouts };
    }

    case shoutout_updated: {
      let shoutouts = [ ...state.shoutouts ];
      let index = shoutouts.indexOf(shoutouts.filter((shoutout) => shoutout._id === action.payload.id)[0]);
      shoutouts[index].text = action.payload.text;
      return { ...state, shoutouts: [ ...shoutouts ] };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/ShoutoutsReducer.js